import { collection, getDocs } from "firebase/firestore";

const fetchRestaurantPerformance = async (db) => {
  try {
    console.log("🏪 Fetching restaurant performance...");
    
    // Fetch all restaurants from the `users` collection
    const usersRef = collection(db, "users");
    const usersSnapshot = await getDocs(usersRef);

    const restaurants = usersSnapshot.docs.map((doc) => ({
      id: doc.id,
      name: doc.data().restaurantName || doc.data().name,
    }));

    console.log("🏪 Found restaurants:", restaurants);

    // Fetch all invoices from the `invoices` collection
    const invoicesRef = collection(db, "invoices");
    const invoicesSnapshot = await getDocs(invoicesRef);

    console.log("🏪 Found invoices:", invoicesSnapshot.docs.length);

    // Aggregate orders and revenue for each restaurant
    const restaurantPerformance = restaurants.map((restaurant) => {
      const restaurantInvoices = invoicesSnapshot.docs.filter(
        (invoiceDoc) => invoiceDoc.data().userId === restaurant.id
      );

      console.log(`🏪 Restaurant ${restaurant.name}: ${restaurantInvoices.length} invoices`);

      const orders = restaurantInvoices.length;
      const revenue = restaurantInvoices.reduce((total, invoiceDoc) => {
        const invoice = invoiceDoc.data();
        const items = invoice.items || [];
        const invoiceRevenue = items.reduce(
          (sum, item) => sum + (parseFloat(item.price) * (item.quantity || 0)),
          0
        );
        console.log(`🏪 Invoice ${invoiceDoc.id} revenue: £${invoiceRevenue.toFixed(2)}`);
        return total + invoiceRevenue;
      }, 0);

      const result = {
        name: restaurant.name,
        orders,
        revenue: parseFloat(revenue.toFixed(2))
      };

      console.log(`🏪 ${restaurant.name} final performance:`, result);
      return result;
    }).filter(restaurant => restaurant.revenue > 0); // Only include restaurants with revenue

    console.log("🏪 Final restaurant performance:", restaurantPerformance);
    return restaurantPerformance;
  } catch (error) {
    console.error("❌ Error fetching restaurant performance:", error);
    return [];
  }
};

export default fetchRestaurantPerformance;
